import type { Workspace } from '@common/modules/workspaces/types'

import type { WorkspaceSettings } from '../../types'

export function workspaceToSettings(workspace: Workspace): WorkspaceSettings {
  return {
    id: workspace.id,
    name: workspace.name,
    logo: workspace.logoUrl,
    dataResidencyRegion: workspace.region,
    createdAt: workspace.createdAt ?? '',
    projectCount: 0,
    memberCount: 0,
  }
}
